import * as React from 'react'
import * as styles from './usDollarsNotice.module.css'

interface INoticeMessage {
  GST: string
  USD: string
  [key: string]: string
}

const USDollarsNotice = ({
  notice,
  styleClassName
}: {
  notice: string | null
  styleClassName: string
}) => {
  const noticeMessages: INoticeMessage = {
    GST: 'All prices are in USD and exclude GST',
    USD: 'All prices are in USD'
  }

  if (notice === null || !noticeMessages[notice]) {
    return null
  }

  return (
    <span className={styleClassName || styles.usDollarsNotice}>
      {noticeMessages[notice]}
    </span>
  )
}

export default USDollarsNotice
